export default {"src":"/_next/static/media/piechart_credit_utilization.87986148.svg","height":250,"width":250};